var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { Text } from "@merge-api/merge-javascript-shared";
export var LogoAvatar = function (_a) {
    var src = _a.src, name = _a.name, _b = _a.size, size = _b === void 0 ? 40 : _b, _c = _a.border, border = _c === void 0 ? false : _c, _d = _a.rounded, rounded = _d === void 0 ? "rounded-lg" : _d, _e = _a.shadow, shadow = _e === void 0 ? false : _e;
    return (_jsx("div", __assign({ className: clsx("flex items-center justify-center", src ? "bg-white p-1" : "bg-gray-10 p-[7px]", rounded, border && "border border-gray-10", shadow && "shadow-sm"), style: { width: "".concat(size, "px"), height: "".concat(size, "px") } }, { children: src ? (_jsx("img", { src: src, alt: name, className: "w-full h-full object-contain" })) : (_jsx(Text, __assign({ className: "text-xs font-semibold text-gray-40" }, { children: name.charAt(0).toUpperCase() }))) })));
};
